import React from 'react'
import ToolsIndex from '../features/tools'
function ToolsPage() {
  return (
    <ToolsIndex />
  )
}

export default ToolsPage